import { AccessTokenConfig, AccessTokenFn } from "@me8eon/access_token";
import { ResponseData } from "me-at-eon/src/services/fetchAndStoreDLSApiKey";
import axios from "axios";
import { decodedTokenToUserData, LoginOutFn, tokenToUserData } from "@me8eon/authentication";
import { DebugLog } from "@me8eon/debug";
import { IStorage } from "@me8eon/storage";
import { dateTimeService, TimeService } from "@me8eon/time";

export function loadDlsApiKey(apiKeyUrl: string): AccessTokenFn {
    return async (debug: DebugLog, login: LoginOutFn, storage: IStorage) => {
        debug("loadDlsApiKey", apiKeyUrl);
        const token = await login(debug);
        const forDebugging = await decodedTokenToUserData(token, storage);
        const expiry = forDebugging.expiry ? new Date(forDebugging.expiry * 1000).toISOString() : "unknown";
        const now = new Date().getTime();
        const valid = forDebugging.expiry ? forDebugging.expiry * 1000 < now : true;
        console.log("loadDlsApiKey", valid, `the token's content`, forDebugging);
        if (!valid) console.error(`Really bad! The token is expired or not valid.`, forDebugging, `The expiry is ${new Date(forDebugging.expiry * 1000).toISOString()} and now is ${new Date(now).toISOString()}`);
        const userData = await tokenToUserData(token, storage);
        debug("loadDlsApiKey", "token and user data", token, userData);
        if (!userData.loggedIn) {
            debug("loadDlsApiKey", "not logged in. returning undefined", token, userData);
            return undefined;
        }
        if (!token) {
            debug("loadDlsApiKey", "no token. returning undefined", token, userData);
            return undefined;
        }
        const url = `${apiKeyUrl}/${userData.email}`;
        debug("loadDlsApiKey", "dls url", url);
        const resp = await axios.get<ResponseData>(
            url,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
        debug("loadDlsApiKey", "dls response", resp);
        //TODO remove these when removing old way of getting dls apikey
        localStorage.setItem("dls-apikey", resp?.data?.encoded);
        localStorage.setItem("admin", resp?.data?.admin?.toString() || "false");
        if (resp?.data?.indicies) {
            localStorage.setItem("dls-accessible-indices", resp.data.indicies);
        }
        return { token: resp?.data?.encoded };
    };
}

export const elasticSearchAccessTokenConfig = (apiKeyUrl: string, timeService: TimeService = dateTimeService): AccessTokenConfig => ({
    fn: loadDlsApiKey(apiKeyUrl),
    timeService,
    ttl: 50 * 60 * 1000, //The token actually lives for 1 hour. So let's say a little less than that
});